export class delay {
    static value() { return 1000;}
    static extraDelay() { return 500;}
}